<template>
  <div
    class="shootingStereogram"
    :class="isAutoExportPng ? 'autoExportPng' : ''"
  >
    <div class="shoots">
      <canvas
        class="canvas"
        ref="shoot"
        @click.stop="downLoad($refs.shoot, false)"
      ></canvas>
    </div>
    <div class="pre_img_right">
      <p>
        <i class="cicle1"></i>
        <span>进球</span>
      </p>
      <p>
        <i class="cicle2"></i>
        <span>射正</span>
      </p>
      <p>
        <i class="cicle3"></i>
        <span>射偏</span>
      </p>
    </div>
  </div>
</template>

<script>
import datas from './shootingStereogram.json'
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'shootingStereogram',
  mixins: [canvasToImage_base64_data_mixin],
  data() {
    return {
      shootData: [],
      parentWidth: 0,
      ratio: 0, // 实际渲染倍率
      initFlag: false,
    }
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  watch: {
    datas() {
      if (this.initFlag) {
        let canvas = this.$refs.shoot
        let ctx = canvas.getContext('2d')
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        this.$nextTick(() => {
          this.render()
        })
      }
    },
  },
  created() {
    // this.datas=datas
  },
  mounted() {
    this.parentWidth = this.$el.clientWidth
    this.changeRatio()
    this.initFlag = true
    this.render()
  },
  methods: {
    changeRatio() {
      let canvas = this.$refs.shoot
      let ctx = canvas.getContext('2d')
      // 屏幕的设备像素比
      let devicePixelRatio = window.devicePixelRatio || 1
      // 浏览器在渲染canvas之前存储画布信息的像素比
      let backingStoreRatio =
        ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio ||
        1
      // canvas的实际渲染倍率
      this.ratio = devicePixelRatio / backingStoreRatio
      canvas.style.width = this.parentWidth + 'px'
      canvas.style.height = (this.parentWidth / 352) * 240 + 'px'
      canvas.width = this.parentWidth * this.ratio
      canvas.height = (this.parentWidth / 352) * 240 * this.ratio
    },
    render() {
      // console.debug("dataList:", this.datas.data.dataList)
      this.shootData = [].concat(this.datas.data.dataList)
      this.shootData.forEach((line) => {
        // console.debug('line:', line)
        for (let i in line) {
          if (i !== 'shot_player_name' && i !== 'player_name') {
            // console.debug(i, line[i])
            line[i] = line[i] * 1
          }
        }
        // this.renderLine(line)
      })
      this.shootData.forEach((line) => {
        // let canvas = this.$refs.shoot;
        // let w = canvas.width
        // let h = canvas.height
        this.renderShoot(line)
      })
      if (this.isAutoExportPng) {
        setTimeout(() => {
          this.upLoad(this.$refs.shoot, false, 'uploadData')
        }, 500)
      }
    },
    renderShoot(point) {
      // 上部的点
      this.renderTopPoint(point)
    },
    renderTopPoint(point) {
      //   console.debug('point:', point)
      let bottomScale = 127 / 240
      let topScale = 113 / 233
      let canvas = this.$refs.shoot
      let ctx = canvas.getContext('2d')
      let w = canvas.width
      let h = canvas.height
      let topHeight = h * topScale
      let bottomHeight = h * bottomScale
      let endx = ((w / 2) * (point.endX + 100)) / 100
      let endy = (topHeight * (100 - point.endY)) / 100
      let radius = 5 * this.ratio
      let beginx = ((w / 2) * (point.startX + 100)) / 100
      let beginy = (bottomHeight * -point.startY) / 100 + topHeight
      this.renderLine(beginx, beginy, endx, endy)
      ctx.beginPath()
      let colors =
        point.type === 1 ? '#CC8FD9' : point.type === 2 ? '#098CCB' : '#D0021B'
      ctx.fillStyle = colors
      ctx.arc(endx, endy, radius, 0, 2 * Math.PI)
      ctx.fill()
      ctx.closePath()
      if (point.startX && point.startY) {
        ctx.beginPath()
        // ctx.moveTo(beginx, beginy)
        // ctx.ellipse(beginx, beginy, 100, 60, 0, 0, Math.PI, true);
        ctx.lineWidth = 3
        ctx.ellipse(beginx, beginy, 20, 10, 0, 0, 2 * Math.PI)
        ctx.stroke()
        ctx.closePath()
      }
      if (point.startX && point.startY) {
        let text = point.player_name + ' ' + point.time + "'"
        ctx.beginPath()
        ctx.font = '10px sans-serif'
        ctx.fillStyle = '#fff'
        ctx.textAlign = 'center'
        ctx.fillText(text, beginx, beginy + 20)
        ctx.closePath()
      }
    },
    renderLine(beginx, beginy, endx, endy) {
      let canvas = this.$refs.shoot
      let ctx = canvas.getContext('2d')
      let LineW = 2 * this.ratio

      ctx.beginPath()
      ctx.strokeStyle = '#fff'
      ctx.lineCap = 'round'
      ctx.lineWidth = LineW
      ctx.moveTo(beginx, beginy)
      ctx.lineTo(endx, endy)
      ctx.stroke()
      ctx.closePath()
    },
  },
}
</script>

<style lang="scss" scoped>
.shootingStereogram {
  position: relative;
  width: 59%;
  &.autoExportPng {
    width: 100%;
  }
}
.shoots {
  width: 96%;
}
.canvas {
  background: var(--mixtmt_shootingStereogram_shoot_bg) 100% 100% no-repeat;
  -webkit-background-size: cover;
  background-size: cover;
}
.pre_img_right {
  position: absolute;
  right: -4.513vw;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 4.166vw;

  & > p {
    display: flex;
    justify-content: flex-start;
    height: 1.388vw;
    align-items: center;
    & > i {
      width: 0.556vw;
      height: 0.556vw;
      border-radius: 50%;
      display: inline-block;
    }
    .cicle1 {
      background: #d0021b;
    }
    .cicle2 {
      background: #098ccb;
    }
    .cicle3 {
      background: #cc8fd9;
    }
    span {
      padding-left: 0.694vw;
      font-size: 0.833vw;
      color: #b9b9b9;
      letter-spacing: 0;
      text-align: center;
    }
  }
}
</style>
